export default function (state) {
    state.items = [];
    state.cbs = [];
    state.loading = false;
}